import { useState } from "react";

import { parseQueryString } from "@warden-ui/common";
import { useNavigate, useSearchParams } from "react-router-dom";
import { cloneSearchParams, isEmailFormat } from "@warden-ui/common";
import { CardContentTeamFind } from "@warden-ui/card-components";
import { CPPageBody } from "@warden-ui/common-components";
import t from "@warden-ui/i18n";

const defaultQueryString: {[key: string]: string} = {
  config: "",
  region: "",
}

export default function TeamFind() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const queryString = parseQueryString(searchParams, defaultQueryString);

  const [errorMessage, setErrorMessage] = useState("");

  const onClickFindTeam = (email: string) => {
    if (!isEmailFormat(email)) {
      setErrorMessage(t('errors.email_invalid'));
      return;
    }

    const params = cloneSearchParams(searchParams);
    params.set("email", email);
    // params.set("self_signup", "false");

    navigate(`/teams/find/sent?${params.toString()}`);
  };

  return (
    <CPPageBody
      onBackClicked={() => navigate(-1)}
    >
      <CardContentTeamFind
        email={queryString.email}
        onClickFindTeam={onClickFindTeam}
        errorMessage={errorMessage}
      />
    </CPPageBody>
  );
}
